<ng-select
    #select
    [items]="items"
    [(ngModel)]="value"
    [loading]="loading"
    [disabled]="disabled || loading"
    bindValue="id"
    [clearable]="false"
    class="multi"
    [ngClass]="{
        'all-checked': (value?.length ?? 0) > 0 && (items?.length ?? 0) === (value?.length ?? 0),
        'limit-dropdown-width': limitDropDownWidth
    }"
    [placeholder]="placeholder ?? 'SELECT.ANY' | translate"
    [multiple]="true"
    [searchable]="false"
    [searchFn]="search"
    [closeOnSelect]="false"
    (ngModelChange)="selectionChanged($event)"
>
    <ng-container *ngIf="showToggleAll || searchable">
        <ng-template ng-header-tmp>
            <div *ngIf="searchable" class="search-header">
                <input
                    type="text"
                    [placeholder]="'SELECT.SEARCH_PLACEHOLDER' | translate"
                    (input)="applyFilter(select, $event)"
                />
                <!-- <app-icon name="magnifying-glass" type="solid" /> -->
                <span class="material-symbols-rounded" aria-hidden="true"> search </span>
                <ng-container *ngTemplateOutlet="toggleAllTemplate" />
            </div>
            <div *ngIf="!searchable" class="select-all-header">
                <ng-container *ngTemplateOutlet="toggleAllTemplate" />
            </div>
        </ng-template>
    </ng-container>

    <ng-template ng-option-tmp let-item="item">
        <fa-icon [icon]="faCheck" size="xs" />
        <span>{{ item.name }}</span>
    </ng-template>

    <ng-template ng-multi-label-tmp let-selectedItems="items">
        <div class="ng-value">
            <ng-container *ngIf="selectedItems.length === (items?.length ?? 0) && showAllText; else notAll">
                <ng-container *ngTemplateOutlet="selectAllLabelTemplate" />
            </ng-container>
            <ng-template #notAll>
                <span *ngIf="selectedItems.length > 1">({{ selectedItems.length }}) </span>
                <span *ngFor="let item of selectedItems; last as isLast">{{ item.name }}{{ !isLast ? ', ' : '' }}</span>
            </ng-template>
        </div>
    </ng-template>
</ng-select>

<ng-template #toggleAllTemplate>
    <div role="button" tabindex="0" (keydown)="handleKeydown($event)" (click)="toggleAll()" class="checkmark-container">
        <fa-icon [icon]="faCheck" size="xs" />
        <ng-container *ngTemplateOutlet="markAllLabelTemplate" />
    </div>
</ng-template>

<ng-template #selectAllLabelTemplate>
    <span *ngIf="toggleAllLabel; else toggleAllWithoutLabelTemplate">{{
        'SELECT.ALL_WITH_LABEL'
            | translate
                : {
                      label: toggleAllLabel
                  }
    }}</span>
    <ng-template #toggleAllWithoutLabelTemplate>
        <span>{{ 'SELECT.ALL' | translate }}</span>
    </ng-template>
</ng-template>

<ng-template #markAllLabelTemplate>
    <span *ngIf="toggleAllLabel; else toggleMarkAllWithoutLabelTemplate">{{
        'SELECT.MARK_ALL_WITH_LABEL'
            | translate
                : {
                      label: toggleAllLabel
                  }
    }}</span>
    <ng-template #toggleMarkAllWithoutLabelTemplate>
        <span>{{ 'SELECT.MARK_ALL' | translate }}</span>
    </ng-template>
</ng-template>
